var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-box-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5148 5.99429L29.5148 9.99429H10V37.9944H38V18.4796L42 14.4796V39.9944C42 41.0988 41.1046 41.9944 40 41.9944H8C6.89544 41.9944 6 41.0988 6 39.9944V7.99429C6 6.88973 6.89544 5.99429 8 5.99429H33.5148ZM40.9706 4.19531L43.799 7.02373L25.4142 25.4086L22.5908 25.4134L22.5858 22.5802L40.9706 4.19531Z",
    fill: "#F78257"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon2);
export default __webpack_public_path__ + "static/media/MissionIcon2.784d95c5e915e0a9a2da28d8ac2b5b3d.svg";
export { ForwardRef as ReactComponent };